const gallery = () => {
	$('.js__gallery-filter').on('click', function(e) {
		e.preventDefault();

		if ( !$(this).hasClass('active') ) {
			const imageCategory = $(this).data('category');
			const filtersForm = $('.views-exposed-form[data-drupal-selector="views-exposed-form-gallery-block-1"]');
			const filterDropdown = filtersForm.find('.form-select');
			const filtersFormSubmit = filtersForm.find('.js-form-submit');

			//filtersForm[0].reset();
			filterDropdown.val(imageCategory);
			filtersFormSubmit.trigger('click');

			$('.js__gallery-filter').removeClass('active');
			$(this).addClass('active');
		}
	});	
};